import React from 'react';

import Button from '../components/Button';
import Hero from '../components/Hero';
import IconContentBlock from '../components/IconContentBlock';
import IndustryList from '../components/IndustryList';
import ContentBlock from '../components/ContentBlock';
import SectionHero from '../components/SectionHero';
import APIShowcase from '../components/APIShowcase';
import Section from '../components/Section';

const GraphQLBaseTemplate = ({ pageContext: { page } }) => {
  const { usps, contentBlocks } = page;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page}>
          <Button
            href="/contact"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Build your own content API &#8594;
          </Button>
        </Hero>
        <div className="md:flex md:flex-wrap -mx-6">
          {usps.map(IconContentBlock)}
        </div>
      </Section>
      <Section colour="light">
        <SectionHero noHr title="Why GraphQL" />
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>
      <Section container="narrow">
        <SectionHero noHr title="GraphQL by Example" />

        <APIShowcase />
      </Section>
    </React.Fragment>
  );
};

export default GraphQLBaseTemplate;
